import { useContext } from 'react';
import AuthContext from '../contexts/authContext';
import { EXPIRING_AFTER_DELTA, EXPIRING_BEFORE_DELTA, PAYMENT_SECTION } from '../constants/constants';
import { isNotNullOrFalse } from './string';
import { ICompanyPayment } from '../common/io/orm/company-payment';

export function isPaymentExpiring(companyPayment?: ICompanyPayment): boolean {
	if (!companyPayment?.expireDate) {
		return false;
	}

	const compare: Date = new Date();
	compare.setDate(compare.getDate() + EXPIRING_BEFORE_DELTA);

	return new Date(companyPayment!.expireDate!) <= compare;
}

export function isPaymentExpired(companyPayment?: ICompanyPayment): boolean {
	if (!companyPayment?.expireDate) {
		return false;
	}
	return new Date(companyPayment!.expireDate!) <= new Date();
}

export function isPaymentExpiredWithExtraTime(companyPayment?: ICompanyPayment): boolean {
	if (!companyPayment?.expireDate) {
		return false;
	}

	const compare: Date = new Date();
	compare.setDate(compare.getDate() - EXPIRING_AFTER_DELTA);

	return new Date(companyPayment!.expireDate!) < compare;
}

export function isCompanyEnabled(section: string): boolean {
	const { companyPayment, companyGroups } = useContext(AuthContext);

	const isPayment: boolean = (companyPayment && companyPayment.paymentType !== 'ND' && !isPaymentExpired(companyPayment)) ?? false;
	const isGroup: boolean = (companyGroups ?? []).length > 0;

	if (!isPayment && !isGroup) {
		return false;
	} else if (isPayment) {
		if (section === PAYMENT_SECTION.COMMITMENT_CALENDAR) {
			return isNotNullOrFalse(companyPayment!.map); // TODO
		}
		if (section === PAYMENT_SECTION.EMPLOYEES) {
			return isNotNullOrFalse(companyPayment!.map); // TODO
		}
		if (section === PAYMENT_SECTION.MAP) {
			return isNotNullOrFalse(companyPayment!.map);
		}
		if (section === PAYMENT_SECTION.PLANNER) {
			return isNotNullOrFalse(companyPayment!.planner);
		}
		if (section === PAYMENT_SECTION.ARCHETYPE) {
			return isNotNullOrFalse(companyPayment!.query) && !isGroup;
		}
		if (section === PAYMENT_SECTION.QUERY) {
			return (companyGroups ?? []).length > 0 || isNotNullOrFalse(companyPayment!.query);
		}
		if (section === PAYMENT_SECTION.TEAM) {
			return isNotNullOrFalse(companyPayment!.team);
		}
	} else {
		return false;
	}

	return true;
}